import React, { useEffect } from 'react';
import AdminLogin from './AdminLogin';

const AdminLoginPage = () => {
  useEffect(() => {
    // Add noindex meta tag for SEO protection
    const metaNoIndex = document.createElement('meta');
    metaNoIndex.name = 'robots';
    metaNoIndex.content = 'noindex, nofollow, noarchive, nosnippet';
    document.head.appendChild(metaNoIndex);

    // Cleanup on unmount
    return () => {
      document.head.removeChild(metaNoIndex);
    };
  }, []);

  return (
    <div className="min-h-screen bg-gray-900 flex items-center justify-center">
      <div className="max-w-md w-full">
        <AdminLogin 
          isOpen={true} 
          onClose={() => window.location.href = '/'} 
        />
      </div>
    </div>
  );
};

export default AdminLoginPage;